const ldTestSortMobile = () => {
    const ratingBlock = document.querySelector('.wpcf7-form-control-wrap[data-name="course_rating"] .wpcf7-form-control');
    if (!ratingBlock) return;

    const items = ratingBlock.querySelectorAll('.wpcf7-list-item');

    const updateCheckedClasses = () => {
        items.forEach(item => {
            const input = item.querySelector('input[type="radio"]');
            if (input && input.checked) {
                item.classList.add('checked');
            } else {
                item.classList.remove('checked');
            }
        });
    };

    items.forEach(item => {
        const input = item.querySelector('input[type="radio"]');
        if (!input) return;

        input.addEventListener('change', updateCheckedClasses);
    });

    updateCheckedClasses();

};

export default ldTestSortMobile;